window.sharer = window.sharer || {};

window.sharer.openCenteredPopup = function (
    url,
    width = 600,
    height = 600
) {
    const left = window.screenX + (window.outerWidth - width) / 2;
    const top = window.screenY + (window.outerHeight - height) / 2;

    window.open(
        url,
        '_blank',
        [
            'popup=yes',
            `width=${width}`,
            `height=${height}`,
            `left=${Math.round(left)}`,
            `top=${Math.round(top)}`,
            'noopener',
            'noreferrer'
        ].join(',')
    );
};

window.sharer.facebook = function ({ url, hashtag }) {
    const shareUrl = new URL('https://www.facebook.com/sharer/sharer.php');

    shareUrl.searchParams.set('u', url);

    if (hashtag) {
        shareUrl.searchParams.set('hashtag', `#${hashtag}`);
    }

    this.openCenteredPopup(shareUrl.toString());
};

window.sharer.x = function ({ url, title, hashtags }) {
    const shareUrl = new URL(
        'https://twitter.com/intent/tweet'
    );

    shareUrl.searchParams.set('url', url);

    if (title) {
        shareUrl.searchParams.set('text', title);
    }

    if (hashtags) {
        shareUrl.searchParams.set('hashtags', hashtags);
    }

    this.openCenteredPopup(shareUrl.toString());
};

window.sharer.email = function ({ subject, body, url }) {
    const content = [
        body,
        '',
        url
    ].filter(Boolean).join('\n');

    window.location.href =
        `mailto:?subject=${encodeURIComponent(subject || '')}` +
        `&body=${encodeURIComponent(content)}`;
};
